// extracted by mini-css-extract-plugin
export default {"selectBeforeHint":"FormDeposit_selectBeforeHint__lvzgm","hint":"FormDeposit_hint__hu14H","icon":"FormDeposit_icon__d7uh6","v2Link":"FormDeposit_v2Link__KK6V3"};